import React from "react";
import { Link } from "react-router-dom";
import styles from "./GalleryAlbumCard.module.css";

/**
 * album: {
 *   event_id: number,
 *   event_slug?: string,
 *   event_title: string,
 *   event_date: string | null,
 *   cover_url: string | null,
 *   flyer_url: string | null,
 * }
 *
 * to: 遷移先（例: `/events/${event_slug}/gallery`）
 */
export default function GalleryAlbumCard({ album, to }) {
  const {
    event_id,
    event_slug,
    event_title,
    event_date,
    cover_url,
    flyer_url,
  } = album;

  const eventPathId = event_slug || event_id;
  const href = to || `/events/${eventPathId}/gallery`;

  const dateLabel = event_date ? formatDateJP(event_date) : "日付未設定";


  return (
    <Link to={href} className={styles.link} aria-label={`${event_title} のギャラリー`}>
      <article className={styles.bookCard}>
        {/* 背表紙 */}
        <div className={styles.spine} aria-hidden="true" />

        {/* 上ラベル */}
        <div className={styles.topRow}>
          <div className={styles.date}>{dateLabel}</div>
        </div>

        {/* 大きいカバー画像 */}
        <div className={styles.coverWrap}>
          {cover_url ? (
            <img className={styles.coverImg} src={cover_url} alt={`${event_title} の写真`} loading="lazy" />
          ) : (
            <div className={styles.coverPlaceholder}>
              <div className={styles.placeholderIcon}>📚</div>
              <div className={styles.placeholderText}>No Photos</div>
            </div>
          )}

          {/* 角金具っぽい装飾 */}
          <span className={styles.cornerTL} aria-hidden="true" />
          <span className={styles.cornerTR} aria-hidden="true" />
          <span className={styles.cornerBL} aria-hidden="true" />
          <span className={styles.cornerBR} aria-hidden="true" />
        </div>

        {/* 下段：左下フライヤー、右下タイトル */}
        <div className={styles.bottomRow}>
          <div className={styles.flyerBox} aria-label="フライヤー">
            {flyer_url ? (
              <img className={styles.flyerImg} src={flyer_url} alt={`${event_title} のフライヤー`} loading="lazy" />
            ) : (
              <div className={styles.flyerPlaceholder}>Flyer</div>
            )}
          </div>

          <h3 className={styles.title} title={event_title}>
            {event_title}
          </h3>
        </div>
      </article>
    </Link>
  );
}

function formatDateJP(input) {
  // input: "YYYY-MM-DD" or ISO string
  const d = new Date(String(input).replace(' ', 'T'));
  if (Number.isNaN(d.getTime())) return input;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}.${m}.${day}`;
}
